import React, { Component } from "react";
import BannerTitle from "../layouts/about/banner/BannerTitle";
import { SideBar, SiteContent } from "../layouts/about/detail";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
import Counter from "../layouts/about/detail/Counter";

import media from "../../data/mediaPartners.json";

class AboutDetails extends Component {
  constructor(props) {
    super(props);

    let mediaPartners = media.mediaPartners.map((x) => {
      return { ...x };
    });

    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "About Us",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/about-us",
          titlelink: "About Us",
          border: "|",
          name: " About us detail",
          heading: "Who we are?",
        },
      ],
      mediaPartners,
    };
  }
  render() {
    const { mediaPartners } = this.state;

    return (
      <div className="header-fixed page sidebar-right width-71 header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <BannerTitle key={data.id} data={data} />
            ))}

            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <SiteContent />
                <SideBar mediaPartners={mediaPartners} />
              </div>
            </div>
            <Counter />
          </div>
          <Footer />
          {this.state.headers.map((data, idx) => (
            <BottomBar data={data} key={idx} />
          ))}
        </div>
      </div>
    );
  }
}

export default AboutDetails;
